import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SkipLink } from '@/components/common/SkipLink';
import { Breadcrumbs } from '@/components/features/Breadcrumbs';

interface LayoutProps {
  children: ReactNode;
}

/**
 * Main layout wrapper with header, footer, and skip link
 */
export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <SkipLink />
      <Header />
      <Breadcrumbs />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
